import { render, staticRenderFns } from "./GiftSearch.vue?vue&type=template&id=8ff24ea4&"
import script from "./GiftSearch.vue?vue&type=script&lang=js&"
export * from "./GiftSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ff24ea4')) {
      api.createRecord('8ff24ea4', component.options)
    } else {
      api.reload('8ff24ea4', component.options)
    }
    module.hot.accept("./GiftSearch.vue?vue&type=template&id=8ff24ea4&", function () {
      api.rerender('8ff24ea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/popup/GiftSearch.vue"
export default component.exports